import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 妖精漫画在线阅读`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-secondary-500 text-background-50 text-xs rounded-md font-medium">
            已完结
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium">
            NEW
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span>{comic.rating}</span>
            <span className="mx-1 opacity-60">·</span>
            <span>{comic.type}</span>
          </div>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors font-heading">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
      </div>
    </Link>
  );
}